import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import "./UserTooltip.css";

const Tooltip = ({ icon, links }) => {
  const [isVisible, setIsVisible] = useState(false);
  const tooltipRef = useRef(null);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setIsVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="tooltip-container" ref={tooltipRef}>
      <FontAwesomeIcon
        icon={faUser}
        className="tooltip-icon"
        style={{ color: "#ffd404" }}
        onClick={() => setIsVisible(!isVisible)}
      />

      {isVisible && (
        <div className="tooltip-content">
          {links.map((link, index) => (
            <React.Fragment key={index}>
              {link.onClick ? (
                <div
                  className="tooltip-item"
                  onClick={(e) => {
                    e.preventDefault();
                    link.onClick();
                    setIsVisible(false);
                  }}
                >
                  {link.label}
                </div>
              ) : (
                <Link
                  to={link.to}
                  className="tooltip-item"
                  onClick={() => setIsVisible(false)}
                >
                  {link.label}
                </Link>
              )}
              {index < links.length - 1 && <div className="tooltip-divider"></div>}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
